import { render, staticRenderFns } from "./excalidraw.vue?vue&type=template&id=50d3a0a0&scoped=true"
import script from "./excalidraw.vue?vue&type=script&lang=js"
export * from "./excalidraw.vue?vue&type=script&lang=js"
import style0 from "./excalidraw.vue?vue&type=style&index=0&id=50d3a0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3a0a0",
  null
  
)

export default component.exports